<select #select class="selectpicker ch-header-item fa" (change)="itemSelected($event)">
  <option *ngFor="let item of items" value="{{ item.value }}" [selected]="value == item.value">{{ item.name }}</option>
</select>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/widgets/select-picker/select-picker.component.html